import { defaultBranding } from "actions/branding";
import { ActionType } from "actions/ActionType";

export default (state = defaultBranding, action) => {
	if (action.type === ActionType.SET_BRANDING_CONFIG) {
		return action.payload;
	}
	return state;
};
